<template>
  <cc-container class="detail">
    <cc-header-nav title="发货单详情">
    </cc-header-nav>
    <cc-main v-if="detail.info">
      <section class="collapse">
        <van-collapse v-model="activeNames" accordion>
          <van-collapse-item name="1">
            <div slot="title" class="collapse-title-box">
              <i class="cc-icon icon-order"></i>
              <p class="collapse-title">
                发货单信息
              </p>
            </div>
            <p class="collapse-item">
              发货单：{{detail.info.delivery_order_number}}
            </p>
            <p class="collapse-item">
              关联单号：
              <span @click="toDetail(item)" style="color: #1BB0D9;" v-for="(item, index) in detail.info.order_number" :key="index">
                {{item + (index === detail.info.order_number.length - 1 ? '' : '、')}}
              </span>
            </p>
            <p class="collapse-item">
              时间：{{detail.info.create_time}}
            </p>
          </van-collapse-item>

          <van-collapse-item title="配送信息" name="2">
            <div slot="title" class="collapse-title-box">
              <i class="cc-icon icon-position"></i>
              <p class="collapse-title">
                配送信息
              </p>
            </div>
            <p class="collapse-item">
              联系人：{{detail.info.contacter}}
            </p>
            <p class="collapse-item">
              联系电话：{{detail.info.mobile}}
            </p>
            <p class="collapse-item">
              收货单位：{{detail.info.customer_name}}
            </p>
            <p class="collapse-item">
              收货地址：{{detail.info.address}}
            </p>
          </van-collapse-item>
        </van-collapse>
      </section>

      <product-list
        :list="detail.goods"
        :checkbox="true"
        @change="handleChange">
        <!-- <product-item @change="handleChange" v-for="item in detail.goods" :key="item.id" :item.sync="item"></product-item> -->
      </product-list>

      <section class="summary-box">
        <div class="checkbox">
          <van-checkbox @click="handleCheckAll" v-model="checked">全选</van-checkbox>
        </div>
        <div>
          <p>
            本单总合计：<span class="price">￥{{detail.info.order_amount}}</span>
          </p>
        </div>
        <div>
          <van-button
            v-if="detail.info.returned"
           style="background: #1BB0D9;border-color: #1BB0D9;" size="small" type="primary"
           @click="handleApplyForReturn"
           >申请退货</van-button>
        </div>
      </section>
    </cc-main>
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
  </cc-container>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { Collapse, CollapseItem, Checkbox, Lazyload, Button, Toast } from 'vant'
import { types } from '@/store/modules/order'
import ProductList from '../components/product-list'
Vue.use(Collapse).use(CollapseItem).use(Checkbox).use(Lazyload).use(Button).use(Toast)
export default {
  name: 'detail',
  components: {
    ProductList
  },
  data () {
    return {
      activeNames: '1',
      checked: true,
      detail: {}
    }
  },
  computed: {
    ...mapGetters(['getBoundDetail'])
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions([types.GET_OUTBOUND_DETAIL]),
    /**
     * @description 全选和反选
     */
    handleCheckAll () {
      this.detail.goods = this.detail.goods.map(item => {
        if (item._returned) {
          item._checked = this.checked
        }
        return item
      })
    },
    /**
     * @description 选中的商品改变
     */
    handleChange (i) {
      const checked = this.detail.goods.every(item => {
        return item._returned && item._checked
      })
      this.checked = checked
    },
    /**
     * @description 跳转订单详情
     */
    toDetail (orderNumber) {
      this.$router.push(`/order/detail/${orderNumber}`)
    },
    /**
     * @description 申请退货
     */
    handleApplyForReturn () {
      const selectedItems = this.detail.goods.filter(item => {
        return (item._returned && item._checked)
      })
      if (selectedItems.length === 0) {
        Toast('至少选中一个商品才可申请退货')
      } else {
        this.$router.push({
          path: `/order/return/apply-for-return`,
          query: {
            type: 1,
            from_id: this.detail.info.id,
            goods_ids: selectedItems.map(item => item.id).toString()
          }
        })
      }
    },
    async loadData () {
      await this.GET_OUTBOUND_DETAIL({
        id: this.$route.params.id
      })
      this.$tips(this.getBoundDetail, res => {
        res.goods = res.goods.map(item => {
          // 可退货
          this.$set(item, '_returned', item.returned === '1')
          this.$set(item, '_checked', item.returned === '1')
          return item
        })
        this.detail = res
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/var.scss';
@import '~styles/mixins.scss';
.detail {
  .collapse {
    box-shadow: $box-shadow-base;
    .collapse-title-box {
      @include flex(row);
      align-items: center;
      .collapse-title {
        padding-left: 10px;
      }
    }
    .collapse-item {
      font-size: 12px;
      color: #333;
      margin-left: 40px;
      line-height: 35px;
      box-sizing: border-box;
      border-bottom: 1px solid #EEEEEE;
      &:last-child {
        border-bottom: 0;
      }
    }
  }
  .checkbox {
    padding-left: 5px;
  }
  .price {
    color: $price-color;
    font-size: 14px;
    line-height: 1;
  }
  .count {
    color: $heading-color;
    font-size: 12px;
    line-height: 1;
  }
  .summary-box {
    @include flex(row);
    align-items: center;
    box-shadow: $box-shadow-base;
    background: #fff;
    height: 40px;
    margin: 8px 0;
    justify-content: space-between;
    padding-right: 10px;
  }
}
.cc-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
}
.icon-order {
  background: url('~assets/img/sprites/order/order.png');
  background-size: 20px 20px;
}
.icon-position {
  background: url('~assets/img/sprites/order/position.png');
  background-size: 20px 20px;
}
</style>
<style lang="scss">
.detail {
  .van-collapse-item__content {
    padding: 0
  }
}
</style>
